import { t as o } from 'i18next';
import { commonFields } from './common-fields';

function t(s) {
  return s;
}

const fields = [
  { name: 'id', displayName: 'Id' },
  { name: 'name', displayName: 'Επωνυμία' },
  { name: 'code', displayName: 'Κωδικός' },
  { name: 'companyVat', displayName: 'ΑΦΜ' },
  { name: 'companyTaxOffice', displayName: 'ΔΟΥ' },
  { name: 'addressLine1', displayName: 'Διεύθυνση' },
  { name: 'addressCity', displayName: 'Πόλη' },
  { name: 'postalCode', displayName: 'Τ.Κ.' },
  { name: 'phone', displayName: 'Τηλέφωνο' },
  { name: 'email', displayName: 'Email' },
  { name: 'notes', displayName: 'Σχόλια' },
  { name: 'categoryId', displayName: 'Κατηγορία' },
  { name: 'regionId', displayName: 'Περιφέρεια' },
  { name: 'subregionId', displayName: 'Περιφερειακή Ενότητα' },

  ...commonFields,
];

// Σχετικές εγγραφές που αλλάζουν από την ίδια φόρμα σημείου συλλογής
const childs = [
  { tableName: 'collectionpoints_waste_categories', keyName: 'collectionpointId' },
];

const collectionpoints = {
  name: 'collectionpoints',
  displayName: 'Σημεία Συλλογής',
  fields: fields,
  childTables: childs,
};

export { collectionpoints };
